import { Controller } from "@hotwired/stimulus"

// AT-1110: aantal-stepper op de ticketstap (epic AT-1100).
//
// Het invoerveld blijft een gewone number-input met dezelfde naam als voorheen
// (products[][amount]), zodat het formulier zonder JS ook werkt en de server niets
// hoeft te weten van deze knoppen.
//
// AT-1113: met een minimum. De oude view rendert een <select> met de opties uit
// Product#product_range -- [0, min_range..max_range] -- dus bij een groepsticket vanaf
// tien personen was 1 daar simpelweg geen optie. De stepper nam alleen het maximum uit
// die reeks over en telde vanaf 0 per 1, waardoor je er wél 1 kon kiezen. Bij De Bonte
// Wever kon je zo een groepsticket voor één persoon in je mandje leggen.
//
// Vandaar: vanaf 0 springt hij naar het minimum, en vanaf het minimum terug naar 0.
// Daartussen valt niets te kiezen, precies zoals in de reeks.
export default class extends Controller {
  static targets = ["input"]
  static values = { max: Number, min: Number }

  increase() {
    const huidig = this.#current()
    this.#setValue(huidig === 0 ? this.#minimum() : huidig + 1)
  }

  decrease() {
    const huidig = this.#current()
    this.#setValue(huidig <= this.#minimum() ? 0 : huidig - 1)
  }

  // Het veld is te typen, en een getypt aantal kwam ongecontroleerd bij de server --
  // die controleert het minimum zelf niet, want de oude shop leunde volledig op de
  // <select>. Bij verlaten van het veld schuift de waarde daarom naar het dichtstbijzijnde
  // toegestane aantal.
  normalize() {
    this.#setValue(this.#current())
  }

  #minimum() {
    return Math.max(this.minValue || 0, 1)
  }

  #current() {
    return parseInt(this.inputTarget.value, 10) || 0
  }

  #setValue(next) {
    const max = this.maxValue || 0
    const min = Math.min(this.#minimum(), max)
    let waarde = Math.min(Math.max(next, 0), max)

    // Tussen 0 en het minimum ligt niets: rond af naar de dichtstbijzijnde van de twee.
    if (waarde > 0 && waarde < min) waarde = waarde * 2 >= min ? min : 0

    // Alleen een change afvuren als er iets veranderd is. Zonder die vergelijking loopt dit
    // vast: normalize hangt aan change (zie _ticket_row), en #setValue vuurt change af, dus
    // increase -> setValue -> change -> normalize -> setValue -> change -> ... tot de stack
    // vol is. De waarde kwam er wel goed uit -- die wordt hieronder gezet vóór de dispatch --
    // maar elke klik op plus of min gooide een RangeError.
    const vorige = this.inputTarget.value
    this.inputTarget.value = waarde
    if (String(waarde) === String(vorige)) return

    // change-event zodat eventuele luisteraars (totaalprijs, validatie) meekrijgen
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
